#import "../fragments/text-automation-fragment.graphql"

query GetTextAutomation($id: ID!) {
    textAutomation(id: $id) {
        ...TextAutomation
    }
}
